import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=89365cf2&scoped=true"
import script from "./NewCompany.vue?vue&type=script&lang=ts"
export * from "./NewCompany.vue?vue&type=script&lang=ts"
import style0 from "./NewCompany.vue?vue&type=style&index=0&id=89365cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89365cf2",
  null
  
)

export default component.exports